import { Component, ViewChild } from '@angular/core';
import { FileTypeConstants } from '../../../../shared/constants/file-upload-type-constants';
import { FileUploadComponent } from '../../../../shared/file-upload/file-upload.component';

@Component({
  selector: 'rental-reimbursement-info',
  templateUrl: './rental-reimbursement-info.component.html'
})
export class RentalReimbursementInfoComponent {
  @ViewChild(FileUploadComponent) fileUpload: FileUploadComponent;

  public acceptedFiles: string[] = [FileTypeConstants.txt, FileTypeConstants.doc, FileTypeConstants.docx, FileTypeConstants.pdf, FileTypeConstants.jpeg, FileTypeConstants.jpg, FileTypeConstants.png, FileTypeConstants.PNG, FileTypeConstants.gif];
  
  public get formCompleted(): boolean {
    // console.count('RentalReimbursementInfoComponent.formCompleted getter called');
    return this.fileUpload.formCompleted;
  };
  public get importFiles(): File[] {
    // console.count('RentalReimbursementInfoComponent.importFiles getter called');
    return this.fileUpload.importFiles;
  }

  constructor() { }

  public validateForm(): void {
    this.fileUpload.validateForm();
  }
}